import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, FileText } from "lucide-react";

export function LegalLayout({ icon: Icon, kicker, title, updated, children }) {
  const navigate = useNavigate();
  return (
    <div className="max-w-3xl mx-auto px-4 pt-8 pb-24 text-white">
      <button
        data-testid="legal-back-btn"
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-1.5 text-sm font-bold text-white/70 hover:text-[#8fbf82] transition-colors mb-6"
      >
        <ArrowLeft size={16} /> Back
      </button>

      <div className="flex items-center gap-2 text-[#5d8a52] font-bold text-sm">
        <Icon size={16} /> {kicker}
      </div>
      <h1 className="text-3xl sm:text-4xl font-extrabold mt-1.5 leading-tight">{title}</h1>
      <p className="text-sm text-[#9a96ac] mt-2">Last updated: {updated}</p>

      <div className="mt-8 space-y-6 text-white/75 text-sm leading-relaxed legal-body sms-tweed rounded-2xl border-2 border-[#5d8a52] p-5 sm:p-7">
        {children}
      </div>

      <div className="mt-12 pt-6 border-t border-white/10 flex items-center gap-4 text-sm font-bold text-[#5d8a52]">
        <Link data-testid="legal-link-privacy" to="/privacy" className="hover:underline">Privacy Policy</Link>
        <span className="text-[#d6d3e0]">·</span>
        <Link data-testid="legal-link-terms" to="/terms" className="hover:underline">Terms of Service</Link>
      </div>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section>
      <h2 className="text-lg font-extrabold text-white mb-1.5">{heading}</h2>
      <div className="space-y-2">{children}</div>
    </section>
  );
}

export { ShieldCheck, FileText };
